import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link, withRouter } from 'react-router-dom';
import Logo from './Logo';

import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
  
} from 'reactstrap';

import ModalLink from './modals/ModalLink';
import { logout, listProjects, loadProject } from '../actions'

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faUser from '@fortawesome/fontawesome-pro-light/faUser';
import faSignOut from '@fortawesome/fontawesome-pro-light/faSignOut';
import faCog from '@fortawesome/fontawesome-pro-light/faCog';
import { currentUserSelector, myProjectsSelector, sharedProjectsSelector, projectsSelector } from '../reducers/selectors';

import map from 'lodash/map';

const mapStateToProps = state => ({ currentUser: currentUserSelector(state), projects: projectsSelector(state), myProjects: myProjectsSelector(state), sharedProjects: sharedProjectsSelector(state), currentProject: state.currentProject});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({logout, listProjects, loadProject}, dispatch);
};

class TopNavbarMenuComponent extends Component {
  
  constructor (props){
    super(props)
    
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.profileClick = this.redirectOnClick.bind(this)
    this.logoutClick = this.logoutClick.bind(this)
    
    this.state = {
      dropdownOpen: false
    }
  }
  
  toggleDropdown (){
    this.setState({dropdownOpen: !this.state.dropdownOpen})
  }
  
  redirectOnClick (to) {
    return (e) => {
      if (e)
        e.preventDefault();
      
      if (to.match(/^http/))
        window.open(to)
      else
        this.props.history.push(to)
      
    }
  }
  
  
  logoutClick(e){
    if (e)
      e.preventDefault();
    this.props.logout()
  }
  
  render() {
    const { currentUser } = this.props;
    if (currentUser)
      return (
        <Nav className="ml-auto" navbar>
          {<NavItem>
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} inNavbar>
              
              <DropdownToggle className="nav-link" color="link" caret>
                <img alt="" src={currentUser.avatar} className="avatar" />  
              </DropdownToggle>
              
              <DropdownMenu isopen={this.dropdownOpen} right>
                <DropdownItem>
                  <nobr><img alt="" src={currentUser.avatar} className="avatar" />  {currentUser.email}</nobr>
                </DropdownItem>
                <DropdownItem onClick={this.redirectOnClick('/pricing')}>
                  Pricing
                </DropdownItem>
                <DropdownItem onClick={this.redirectOnClick('/profile')}>
                  Profile
                </DropdownItem>
                
                
                <DropdownItem onClick={this.logoutClick}>Logout <FA className="float-right" icon={faSignOut} /></DropdownItem>
              </DropdownMenu>
              
              
            </Dropdown>
            
            {false && <Link to="/profile" className="nav-link" title={currentUser.email}>
              <img alt="" src={currentUser.avatar} className="avatar" /> {currentUser.email} {false && <FA icon={faUser} />}
            </Link>}
            
          </NavItem>}
        </Nav>
      );
    else
      return (
        <Nav className="ml-auto" navbar>
          <NavItem>
            <Link to="/login" className="nav-link">Login</Link>
          </NavItem>
          <NavItem>
            <Link to="/register" className="nav-link">Sign up</Link>
          </NavItem>
        </Nav>
      );
  }
}


const TopNavbarMenu = withRouter(TopNavbarMenuComponent)



const ProjectsMenuItems = ({myProjects, sharedProjects, loadProject}) => {
  
  return (<React.Fragment>
    {myProjects.length > 0 && <DropdownItem header>My Projects</DropdownItem>}
    {map(myProjects, (project, idx) => (
      <DropdownItem key={idx} onClick={() => loadProject(project.id)}>
        {project.name}
      </DropdownItem>
    ))}
    {sharedProjects.length > 0 && <DropdownItem header>Shared Projects</DropdownItem>}
    {map(sharedProjects, (project) => (
      <DropdownItem key={project.id} onClick={() => loadProject(project.id)}>
        {project.name}
      </DropdownItem>
    ))}
  </React.Fragment>)
}


class ProjectsNavbarMenu extends Component {
  
  constructor (props){
    super(props)
    
    this.toggleDropdown = this.toggleDropdown.bind(this)
    
    this.state = {
      dropdownOpen: false
    }
  }
  
  componentWillMount (){
    const { currentUser, listProjects} = this.props;
    if (currentUser)
      listProjects()
  }
  
  toggleDropdown (){
    this.setState({dropdownOpen: !this.state.dropdownOpen})
  }
  
  render() {
    const { currentUser, currentProject, myProjects, sharedProjects, loadProject } = this.props;
    
    if (currentUser)
      return (
        <Nav className="ml-0" navbar>
          {<NavItem>
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} inNavbar>
              
              <DropdownToggle className="nav-link" color="link" caret>
                {currentProject.name}
              </DropdownToggle>
              
              <DropdownMenu right>
                <ProjectsMenuItems {...{myProjects, sharedProjects, loadProject}}/>
                <ModalLink key={'add-new-project'} params={{onSuccess: this.onCreateSuccess}} to="newProject" className="dropdown-item dropdown-item-primary text-center">add new project</ModalLink>
              </DropdownMenu>
              
            </Dropdown>
            { currentProject.is_owner && <ModalLink key={`edit-project-${currentProject.id}`} params={{projectId: currentProject.id}} className="btn-text" to="editProject"><FA icon={faCog} /></ModalLink>}
          </NavItem>}
        </Nav>
      );
    else
      return null;
  }
}



class TopNavbar extends Component {
  
  constructor(props) {
    super(props);
    
    this.toggleNav = this.toggleNav.bind(this);
    this.state = {
      ...this.state,
      isOpen: false
    };
  }
  
  toggleNav() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  
  render() {
    return (
      <Navbar light className="bg-white navbar-shadow" expand="sm">
        <Container>
          <Logo className="mr-3" />
          <NavbarToggler left="false" onClick={this.toggleNav} />
          
          <Collapse isOpen={this.state.isOpen} navbar>
            <ProjectsNavbarMenu {...this.props} />
            <TopNavbarMenu {...this.props} />
          </Collapse>
          
        </Container>
        
      </Navbar>
    );
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(TopNavbar);


// WEBPACK FOOTER //
// ./src/components/TopNavbar.js